<script setup lang="ts">
import type { CreditProduct } from '~/composables/credit';

import {
	useCreditSimulator,
	useCreditSimulatorAnchor
} from '~/composables/credit';

import { CREDIT_GOALS } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';

const simulator = useCreditSimulator();
const { scrollToSimulator } = useCreditSimulatorAnchor();

function openProduct(product: CreditProduct) {
	simulator.startProduct(product);
	scrollToSimulator();
}
</script>

<template>
	<section class="px-6 pt-26 pb-24">
		<div class="mx-auto max-w-[1240px]">
			<div class="max-w-[720px]">
				<CreditSectionTitle>
					Comece pelo seu objetivo.<br />A gente encontra o produto.
				</CreditSectionTitle>
				<p class="mt-4.5 mb-0 text-[18px] leading-[1.6] text-[#A3A3A3]">
					Cada caminho tem custo, prazo e exigências diferentes. Escolha o que
					você quer fazer e veja quanto custa.
				</p>
			</div>
			<div
				class="mt-12 grid grid-cols-[repeat(auto-fit,minmax(270px,1fr))] gap-5"
			>
				<div
					v-for="goal in CREDIT_GOALS"
					:key="goal.product"
					class="flex flex-col gap-3.5 rounded-xs border border-[#262626] bg-[#111111] p-7"
				>
					<div v-if="goal.badge" class="flex items-center justify-between">
						<span
							class="text-[12px] font-medium tracking-[1.2px] text-beige uppercase"
						>
							{{ goal.category }}
						</span>
						<span
							class="rounded-xs bg-beige px-2.5 py-1 text-[12px] text-black"
						>
							{{ goal.badge }}
						</span>
					</div>
					<span
						v-else
						class="text-[12px] font-medium tracking-[1.2px] text-beige uppercase"
					>
						{{ goal.category }}
					</span>
					<div class="text-[22px] leading-[1.25] font-medium">
						{{ goal.title }}
					</div>
					<div class="flex-1 text-[15px] leading-[1.6] text-[#A3A3A3]">
						{{ goal.description }}
					</div>
					<a
						href="#simulador"
						class="inline-flex min-h-11 items-center gap-2 font-medium text-beige no-underline hover:text-[#F0DDBF]"
						@click.prevent="openProduct(goal.product)"
					>
						{{ goal.cta }} <span aria-hidden="true">→</span>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>
